import { GridComponent } from './grid.component';
import { MapGridComponent } from './map-grid.component';

export { GridBaseComponent, SelectableGridBaseComponent, RowSelection, SelectionEvent } from './grid-base.component';

export * from './Grids';

import { RowCheckBoxComponent } from './row-checkbox.component';
import { RowCheckBoxParentComponent } from './row-checkbox-parent.component';

export const GRID_COMPONENTS = [
  RowCheckBoxComponent,
  RowCheckBoxParentComponent,
  GridComponent
];

export {
  GridComponent,
  MapGridComponent,
  RowCheckBoxComponent,
  RowCheckBoxParentComponent
};



// WEBPACK FOOTER //
// ./src/app/shared/components/grids/index.ts